import { ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild, inject, DestroyRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
  hydratedGlobalParams,
} from '../../../shared/workspace-element-context';
import { RecurringMultiYearTaxAdjustmentService } from '../../services/recurring-multi-year-tax-adjustment.service';
import * as _ from 'lodash-es';

@Component({
    selector: 'app-recurring-multi-year-tax-adjustment',
    templateUrl: './recurring-multi-year-tax-adjustment.component.html',
    styleUrls: ['./recurring-multi-year-tax-adjustment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RecurringMultiYearTaxAdjustmentComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  @ViewChild('rmytaForm') rmytaForm!: NgForm;

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private isInitialized = false;

  private tryInit(): void {
    if (!this.isInitialized &&
        this.GENERAL_CONFIG && this.GENERAL_CONFIG.base_url &&
        this.rowData && Object.keys(this.rowData).length > 0 &&
        this.filterParams !== undefined) {
      this.isInitialized = true;
      this.init();
    }
  }

  // Component properties
  modal_name: boolean = true;
  title: string = 'Recurring Multiyear Tax Adjustment';
  currentTabName: string = 'Recurring Multiyear Tax Adjustment';
  minimise: boolean = false;
  isSaveClicked: boolean = false;
  crudLoading: boolean = false;
  mandatoryFieldsOpen: boolean = true;
  adjustmentScheduleOpen: boolean = true;
  
  // Config objects
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  SERVER_CONFIG: any = {};
  globalService: any = { globalParams: {} };
  filterParams: any = {};
  rowData: any = {};

  // Entity data
  entityData: any = {};

  // Section 1 data
  testflag: boolean = false;
  triggerloading: boolean = false;
  gloading: boolean = false;
  postingGL: string = '';
  postinggl_acct: any[] = [];
  postinggl_acct_M: any[] = [];
  postingGLError: boolean = false;
  postingTax: string = '';
  postingTax_acct: any[] = [];
  m3formline: string = '';
  dcscurr: string = 'USD';
  bookamt: any = 0;
  bookadj: any = 0;
  taxadj: any = 0;
  posting_tac_key: string = '';
  posting_acct_key: string = '';

  // Mandatory fields
  template: string = '';
  templateLoading: boolean = false;
  templateError: boolean = false;
  tempsystemaccount: any[] = [];
  mainmodaldata: any[] = [];
  mainmodaldata_t: any[] = [];
  
  userm1: string = '';
  userDescError: boolean = false;
  old_userm1_desc: string = '';
  
  schdmt: string = '';
  schdmtype: any[] = [];
  schdmtypedata: any[] = [];
  schdmloading: boolean = false;
  hideschdmtype: boolean = false;
  typeError: boolean = false;
  old_schdmt: string = '';
  
  tbbsacctval: string = '';
  tbbsacct: any[] = [];
  tbbsacctdata: any[] = [];
  tbbsacctdataMain: any[] = [];
  tbbsLoading: boolean = false;
  hidetbbss: boolean = false;
  tbbsError: boolean = false;
  
  beginYear: any = '';
  endYear: any = '';
  currentTaxYear: number = 0;
  beginYearError: boolean = false;
  endYearError: boolean = false;
  endYearErrormaxyear: boolean = false;
  readonlybeginyear: boolean = false;
  
  annual_adjustment_amount: any = 0;
  annual_adjustment_amount_error: boolean = false;
  
  // View adjustment schedule
  canViewAdjustmentSchedule: boolean = false;
  viewAdjustmentScheduleArray: any[] = [];
  
  // Existing adjustments
  mainExistingData: any[] = [];
  main_existing_data_loading: boolean = true;
  noRecords: boolean = false;
  
  // Save data
  TYPE: string = 'I';
  saveDataArray: any[] = [];
  schdmid: number = 0;
  
  // Old values for edit mode
  old_posting_acct_key: string = '';
  old_posting_tac_key: string = '';
  old_template_id: string = '';
  old_schdm_type: string = '';
  old_tbbs_acct: string = '';
  old_beginYear: any = '';
  old_endYear: any = '';
  old_annual_adjustment_amount: any = '';

  constructor(
    private recurringMultiYearTaxAdjustmentService: RecurringMultiYearTaxAdjustmentService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) { }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalService = header;
    this.USER_SETTINGS = header.userSettingsData || {};
    this.SERVER_CONFIG = header.serverConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.tryInit();
    this.cdr.markForCheck();
  }

  init(): void {
    console.log('RecurringMultiYear: init() called');
    console.log('RecurringMultiYear: GENERAL_CONFIG:', this.GENERAL_CONFIG);
    console.log('RecurringMultiYear: GENERAL_CONFIG.base_url:', this.GENERAL_CONFIG.base_url);
    console.log('RecurringMultiYear: globalService:', this.globalService);
    console.log('RecurringMultiYear: rowData:', this.rowData);
    console.log('RecurringMultiYear: filterParams:', this.filterParams);
    
    this.setupEntityData();
    this.initSection1();
    this.initMandatorySection();
    this.initViewAdjustmentScheduleSection();
    this.getExistingRecurringTaxadj();
    this.crudLoading = false;
    this.readonlybeginyear = false;
    this.cdr.markForCheck();
  }

  setupEntityData(): void {
    console.log('RecurringMultiYear: setupEntityData - rowData:', this.rowData);
    this.entityData = {
      LE_NAME: this.rowData.LE_NAME || '',
      ME_CODE: this.rowData.ME_CODE || '',
      ME_NAME: this.rowData.ME_NAME || '',
      TAX_CODE: this.rowData.TAX_CODE || '',
      CHART_CODE: this.rowData.CHART_CODE || '',
      CHART_DESC: this.rowData.CHART_DESC || '',
      LEDGER: this.rowData.LEDGER || ''
    };
    console.log('RecurringMultiYear: setupEntityData - entityData:', this.entityData);
  }

  initSection1(): void {
    this.testflag = false;
    this.triggerloading = false;
    this.gloading = false;
    this.postinggl_acct = [];
    this.postingTax_acct = [];
    this.dcscurr = 'USD';
    this.getglAccts();
  }

  getglAccts(): void {
    const globalParams = this.globalService?.globalParams || {};
    
    this.triggerloading = true; // Set to true to show fields
    
    this.recurringMultiYearTaxAdjustmentService.getGLAccounts(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      this.rowData.CHART_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.gloading = true;
        } else {
          this.postinggl_acct_M = data.jsonObject || [];
          this.postinggl_acct = this.postinggl_acct_M.map((item: any) => item.GL_ACCT);
          this.postinggl_acct = _.uniq(this.postinggl_acct);
          this.gloading = true;
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading GL accounts:', error);
        this.showSnackBar('Error loading GL accounts', 'error');
        this.gloading = true;
        this.cdr.markForCheck();
      }
    });
  }

  callFun(row: any): void {
    this.triggerloading = false;
    let posting_acct_key = '';
    
    for (const item of this.postinggl_acct_M) {
      if (item.GL_ACCT === row) {
        posting_acct_key = item.GL_ACCT_KEY;
        break;
      }
    }
    
    const globalParams = this.globalService?.globalParams || {};
    
    this.recurringMultiYearTaxAdjustmentService.getTriggerData(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      this.rowData.COMBINATION_KEY,
      posting_acct_key
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.triggerloading = true;
        } else {
          const triggerdata = data.jsonObject || [];
          
          if (triggerdata.length > 0) {
            this.postingTax = triggerdata[0].POSTING_TAC;
            this.m3formline = triggerdata[0].M3_ACCT;
            this.bookamt = triggerdata[0].BOOK_AMT;
            this.bookadj = triggerdata[0].BOOK_ADJ;
            this.taxadj = triggerdata[0].TAX_ADJ;
            this.posting_tac_key = triggerdata[0].POSTING_TAC_KEY;
            this.posting_acct_key = triggerdata[0].POSTING_ACCT_KEY;
            this.loadtemplatedata(this.posting_tac_key, this.posting_acct_key);
          }
          this.triggerloading = true;
          this.changePostingglerror();
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading trigger data:', error);
        this.showSnackBar('Error loading trigger data', 'error');
        this.triggerloading = true;
        this.cdr.markForCheck();
      }
    });
  }

  initMandatorySection(): void {
    this.template = '';
    this.templateLoading = false;
    this.templateError = false;
    this.tbbsError = false;
    this.userm1 = '';
    this.schdmt = '';
    this.tempsystemaccount = [];
    this.mainmodaldata = [];
    this.tbbsacctdata = [];
    this.schdmtypedata = [];
    this.mainmodaldata_t = [];
    this.tbbsacctdataMain = [];
    this.mainExistingData = [];
    
    const globalParams = this.globalService?.globalParams || {};
    this.currentTaxYear = globalParams.tax_year || 0;
    
    this.beginYear = '';
    this.endYear = '';
    this.beginYearError = false;
    this.endYearError = false;
    this.endYearErrormaxyear = false;
    this.annual_adjustment_amount = 0;
    this.annual_adjustment_amount_error = false;
    this.posting_tac_key = '';
    this.posting_acct_key = '';
    this.schdmid = 0;
  }

  loadtemplatedata(posting_tac_key: string, posting_acct_key: string): void {
    this.mainmodaldata = [];
    this.templateLoading = true;
    
    const globalParams = this.globalService?.globalParams || {};
    const sys_acct = `${this.rowData.CHART_KEY}_${posting_acct_key}-${posting_tac_key}`;
    
    this.recurringMultiYearTaxAdjustmentService.getTemplateData(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      sys_acct
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.templateLoading = false;
        } else {
          this.mainmodaldata_t = data.jsonObject || [];
          this.tempsystemaccount = this.mainmodaldata_t.map((item: any) => item.SCHDM_TEMPLATE);
          this.tempsystemaccount = _.uniq(this.tempsystemaccount);
          this.templateLoading = false;
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading template data:', error);
        this.showSnackBar('Error loading template data', 'error');
        this.templateLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  getExistingRecurringTaxadj(): void {
    this.mainExistingData = [];
    this.main_existing_data_loading = true;
    
    const globalParams = this.globalService?.globalParams || {};
    
    this.recurringMultiYearTaxAdjustmentService.getExistingData(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      this.rowData.COMBINATION_KEY,
      this.rowData.POSTING_ACCT_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.main_existing_data_loading = false;
        } else {
          this.mainExistingData = data.jsonObject || [];
          this.main_existing_data_loading = false;
          this.noRecords = this.mainExistingData.length === 0;
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading existing data:', error);
        this.showSnackBar('Error loading existing data', 'error');
        this.main_existing_data_loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  loadAdjustment(index: any): void {
    this.TYPE = 'E';
    this.posting_acct_key = index.POSTING_ACCT_KEY;
    this.posting_tac_key = index.POSTING_TAC_KEY;
    
    this.loadtemplatedata(index.POSTING_TAC_KEY, index.POSTING_ACCT_KEY);
    this.loadschdmtype_temp(index);
  }

  loadschdmtype_temp(index: any): void {
    const globalParams = this.globalService?.globalParams || {};
    const sys_acct = `${this.rowData.CHART_KEY}_${this.posting_acct_key}-${this.posting_tac_key}`;
    
    this.recurringMultiYearTaxAdjustmentService.getSchdMType(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      sys_acct,
      index.SCHDM_TEMPLATE_ID
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.schdmloading = false;
          this.hideschdmtype = false;
        } else {
          this.schdmtypedata = data.jsonObject || [];
          this.schdmtype = this.schdmtypedata.map((item: any) => item.SCHDM_TYPE);
          this.schdmtype = _.uniq(this.schdmtype);
          this.hideschdmtype = false;
          this.schdmloading = false;
          
          this.loadtbbsdata_temp(index);
          
          if (this.schdmtype.length < 1) {
            this.hideschdmtype = true;
          }
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading SchdM type:', error);
        this.showSnackBar('Error loading SchdM type', 'error');
        this.schdmloading = false;
        this.cdr.markForCheck();
      }
    });
  }

  loadtbbsdata_temp(index: any): void {
    let temp_schdm_type = '';
    for (const item of this.schdmtypedata) {
      if (item.SCHDM_TYPE === index.SCHDM_TYPE) {
        temp_schdm_type = item.SCHDM_TYPE_SAVE;
        break;
      }
    }
    
    const globalParams = this.globalService?.globalParams || {};
    
    this.recurringMultiYearTaxAdjustmentService.getTBBSData(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      this.posting_acct_key,
      this.rowData.CHART_KEY,
      index.SCHDM_TEMPLATE_ID,
      'D',
      temp_schdm_type,
      this.rowData.COMBINATION_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.hidetbbss = false;
          this.tbbsLoading = false;
        } else {
          this.tbbsacctdataMain = data.jsonObject || [];
          this.tbbsacctdata = data.jsonObject || [];
          this.tbbsacct = this.tbbsacctdata.map((item: any) => item.TAX_STREAM_ACCT);
          this.tbbsacct = _.uniq(this.tbbsacct);
          this.hidetbbss = false;
          this.tbbsLoading = false;
          
          if (this.tbbsacct.length < 1) {
            this.hidetbbss = true;
          }
          
          // Continue loading adjustment data
          this.finishLoadingAdjustment(index);
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading TBBS data:', error);
        this.showSnackBar('Error loading TBBS data', 'error');
        this.tbbsLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  finishLoadingAdjustment(index: any): void {
    const _data = this.mainExistingData.filter((item: any) => item.SCHDM_ID === index.SCHDM_ID);
    
    for (const pgl of this.postinggl_acct_M) {
      if (index.POSTING_ACCT_KEY === pgl.GL_ACCT_KEY) {
        this.postingGL = pgl.GL_ACCT;
        this.callFun(this.postingGL);
        break;
      }
    }
    
    this.old_posting_acct_key = index.POSTING_ACCT_KEY;
    this.old_posting_tac_key = index.POSTING_TAC_KEY;
    this.old_template_id = index.SCHDM_TEMPLATE_ID;
    this.old_schdm_type = index.SCHDM_TYPE;
    this.old_tbbs_acct = index.TBBS_ACCT_KEY;
    this.old_beginYear = index.BEGIN_YEAR;
    this.old_endYear = index.END_YEAR;
    this.schdmt = index.SCHDM_TYPE;
    this.old_schdmt = index.SCHDM_TYPE;
    
    this.beginYear = index.BEGIN_YEAR;
    if (this.beginYear < this.currentTaxYear) {
      this.readonlybeginyear = true;
    }
    this.endYear = index.END_YEAR;
    this.annual_adjustment_amount = index.ANNUAL_AMT;
    this.old_annual_adjustment_amount = index.ANNUAL_AMT;
    this.template = index.SCHDM_DESC;
    this.userm1 = index.USER_DESC;
    this.old_userm1_desc = this.userm1;
    
    this.tbbsacctval = `${index.TBBS_ACCT}-${index.TBBS_ACCT_DESC}`;
    this.schdmid = index.SCHDM_ID;
    
    this.viewAdjustmentScheduleArray = [];
    this.canViewAdjustmentSchedule = true;
    
    for (const ayear of _data) {
      const bottomyearreadonly = ayear.ADJ_TAX_YEAR < this.currentTaxYear;
      this.viewAdjustmentScheduleArray.push({
        year: ayear.ADJ_TAX_YEAR,
        value: ayear.ADJ_AMT,
        old_year: ayear.ADJ_TAX_YEAR,
        old_value: ayear.ADJ_AMT,
        readonlyflag: bottomyearreadonly
      });
    }
    
    this.checktemplateError();
    this.checktypeError();
    this.tbbsChange();
    this.annual_adjustment_amount_change();
    
    if (index.VALIDATION_CHECK_FLAG === 'N') {
      if (this.beginYear && (this.beginYear >= this.currentTaxYear)) {
        this.beginYearError = false;
      } else {
        this.beginYearError = true;
      }
    }
    
    if (this.endYear && (this.endYear >= this.beginYear)) {
      this.endYearError = false;
      if (this.endYear > this.beginYear + 50) {
        this.endYearErrormaxyear = true;
      } else {
        this.endYearErrormaxyear = false;
      }
    } else {
      this.endYearError = true;
      this.endYearErrormaxyear = false;
    }
  }

  changeTemplate(): void {
    this.schdmt = '';
    this.tbbsacctval = '';
    this.loadtbbsdata();
    this.loadschdmtype();
    
    for (const item of this.mainmodaldata_t) {
      if (item.SCHDM_TEMPLATE === this.template) {
        this.userm1 = item.USER_DESC;
        break;
      }
    }
    this.checktemplateError();
  }

  loadschdmtype(): void {
    let schdm_temp = '';
    this.hideschdmtype = false;
    this.schdmloading = true;
    
    for (const item of this.mainmodaldata_t) {
      if (item.SCHDM_TEMPLATE === this.template) {
        schdm_temp = item.SCHDM_TEMPLATE_ID;
        break;
      }
    }
    
    const globalParams = this.globalService?.globalParams || {};
    const sys_acct = `${this.rowData.CHART_KEY}_${this.posting_acct_key}-${this.posting_tac_key}`;
    
    this.recurringMultiYearTaxAdjustmentService.getSchdMType(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      sys_acct,
      schdm_temp
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.schdmloading = false;
          this.hideschdmtype = false;
        } else {
          this.schdmtypedata = data.jsonObject || [];
          this.schdmtype = this.schdmtypedata.map((item: any) => item.SCHDM_TYPE);
          this.schdmtype = _.uniq(this.schdmtype);
          this.hideschdmtype = false;
          this.schdmloading = false;
          
          if (this.schdmtype.length < 1) {
            this.hideschdmtype = true;
          }
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading SchdM type:', error);
        this.showSnackBar('Error loading SchdM type', 'error');
        this.schdmloading = false;
        this.cdr.markForCheck();
      }
    });
  }

  loadtbbsdata(): void {
    this.hidetbbss = false;
    this.tbbsLoading = true;
    let schdm_temp_tbbs = '';
    this.tbbsacct = [];
    this.tbbsacctdata = [];
    
    for (const item of this.mainmodaldata_t) {
      if (item.SCHDM_TEMPLATE === this.template) {
        schdm_temp_tbbs = item.SCHDM_TEMPLATE_ID;
        break;
      }
    }
    
    let temp_schdm_type = '';
    for (const item of this.schdmtypedata) {
      if (item.SCHDM_TYPE === this.schdmt) {
        temp_schdm_type = item.SCHDM_TYPE_SAVE;
        break;
      }
    }
    
    const globalParams = this.globalService?.globalParams || {};
    
    this.recurringMultiYearTaxAdjustmentService.getTBBSData(
      this.GENERAL_CONFIG.base_url,
      globalParams.tax_year,
      globalParams.scenario,
      globalParams.jcd_key,
      this.posting_acct_key,
      this.rowData.CHART_KEY,
      schdm_temp_tbbs,
      'D',
      temp_schdm_type,
      this.rowData.COMBINATION_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        if (data.callSuccess !== '1') {
          this.showSnackBar(data.errorMessage, 'error');
          this.hidetbbss = false;
          this.tbbsLoading = false;
        } else {
          this.tbbsacctdataMain = data.jsonObject || [];
          this.tbbsacctdata = data.jsonObject || [];
          this.tbbsacct = this.tbbsacctdata.map((item: any) => item.TAX_STREAM_ACCT);
          this.tbbsacct = _.uniq(this.tbbsacct);
          this.hidetbbss = false;
          this.tbbsLoading = false;
          
          if (this.tbbsacct.length < 1) {
            this.hidetbbss = true;
          }
        }
        this.cdr.markForCheck();
      },
      error: (error: any) => {
        console.error('Error loading TBBS data:', error);
        this.showSnackBar('Error loading TBBS data', 'error');
        this.tbbsLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  typeChange(): void {
    this.tbbsacctval = '';
    this.loadtbbsdata();
    this.checktypeError();
  }

  checktypeError(): void {
    this.typeError = !this.schdmt || this.schdmt === '';
  }

  tbbsChange(): void {
    this.tbbsError = !this.tbbsacctval || this.tbbsacctval === '';
  }

  checktemplateError(): void {
    this.templateError = !this.template || this.template === '';
    this.m1Desc();
  }

  changePostingglerror(): void {
    this.postingGLError = !this.postingGL || this.postingGL === '';
  }

  m1Desc(): void {
    this.userDescError = !this.userm1 || this.userm1 === '';
  }

  beginYearChange(): void {
    if (this.beginYear && (this.beginYear >= this.currentTaxYear)) {
      this.beginYearError = false;
    } else {
      this.beginYearError = true;
    }
    this.setupViewAdjustmentSchedule();
  }

  endYearChange(): void {
    if (this.endYear && (this.endYear >= this.beginYear)) {
      this.endYearError = false;
      if (this.endYear > this.beginYear + 50) {
        this.endYearErrormaxyear = true;
      } else {
        this.endYearErrormaxyear = false;
      }
    } else {
      this.endYearError = true;
      this.endYearErrormaxyear = false;
    }
    this.setupViewAdjustmentSchedule();
  }

  annual_adjustment_amount_change(): void {
    this.annual_adjustment_amount_error = !this.annual_adjustment_amount || this.annual_adjustment_amount === '';
  }

  initViewAdjustmentScheduleSection(): void {
    this.canViewAdjustmentSchedule = false;
    this.viewAdjustmentScheduleArray = [];
  }

  setupViewAdjustmentSchedule(): void {
    this.canViewAdjustmentSchedule = (this.endYear - this.beginYear) >= 0;
    this.viewAdjustmentScheduleArray = [];
    if (this.canViewAdjustmentSchedule) {
      this.createViewAdjustmentScheduleArray();
    }
  }

  createViewAdjustmentScheduleArray(): void {
    for (let i = this.beginYear; i <= this.endYear; i++) {
      const bottomyearreadonly = i < this.currentTaxYear;
      this.viewAdjustmentScheduleArray.push({
        year: i,
        value: this.annual_adjustment_amount,
        readonlyflag: bottomyearreadonly
      });
    }
  }

  applyButton(index: number): void {
    this.viewAdjustmentScheduleArray[index].value = this.annual_adjustment_amount;
  }

  save(): void {
    if (this.isValidated()) {
      this.prepareData();
      
      if (this.crudLoading) {
        this.showSnackBar('Please wait while we save this request', 'info');
        return;
      }
      
      this.crudLoading = true;
      
      const globalParams = this.globalService?.globalParams || {};
      
      this.recurringMultiYearTaxAdjustmentService.saveData(
        this.GENERAL_CONFIG.base_url,
        this.saveDataArray,
        globalParams,
        this.filterParams
      ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response: any) => {
          if (response.errorMessage && response.errorMessage !== 'null') {
            this.showSnackBar(response.errorMessage, 'error');
            this.crudLoading = false;
            this.cdr.markForCheck();
            return;
          }
          this.showSnackBar('Data saved for Recurring Multiyear Tax Adjustments', 'success');
          this.requestGridUpdate.emit('refresh');
          this.crudLoading = false;
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          console.error('Error saving data:', error);
          this.showSnackBar('Service Failed: contact helpdesk', 'error');
          this.crudLoading = false;
          this.cdr.markForCheck();
        }
      });
    }
  }

  reset(): void {
    this.init();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  isValidated(): boolean {
    this.postingGLError = !this.postingGL;
    this.templateError = !this.template;
    this.tbbsError = !this.tbbsacctval;
    this.userDescError = !this.userm1;
    this.typeError = !this.schdmt;
    this.beginYearError = !this.beginYear;
    this.endYearError = !this.endYear;
    this.annual_adjustment_amount_error = !this.annual_adjustment_amount;
    
    return !(this.templateError || this.userDescError || this.typeError ||
      this.beginYearError || this.endYearError || this.annual_adjustment_amount_error ||
      this.tbbsError || this.postingGLError);
  }

  prepareData(): void {
    this.saveDataArray = [];
    for (let i = 0; i <= (this.endYear - this.beginYear); i++) {
      this.saveDataArray.push(this.getSaveDataObject(i));
    }
  }

  getSaveDataObject(i: number): any {
    const globalParams = this.globalService?.globalParams || {};
    
    if (this.TYPE === 'I') {
      let modalT_key = '';
      let tbbs_key = '';
      let posting_acct_key = '';
      let schdm_type_key = '';
      
      for (const t of this.mainmodaldata_t) {
        if (t.SCHDM_TEMPLATE === this.template) {
          modalT_key = t.SCHDM_TEMPLATE_ID;
          break;
        }
      }
      
      for (const tb of this.tbbsacctdataMain) {
        if (tb.TAX_STREAM_ACCT === this.tbbsacctval) {
          tbbs_key = tb.TAX_STREAM_ACCT_SAVE;
          break;
        }
      }
      
      for (const pt of this.postinggl_acct_M) {
        if (pt.GL_ACCT === this.postingGL) {
          posting_acct_key = pt.GL_ACCT_KEY;
          break;
        }
      }
      
      for (const z of this.schdmtypedata) {
        if (z.SCHDM_TYPE === this.schdmt) {
          schdm_type_key = z.SCHDM_TYPE_SAVE;
          break;
        }
      }
      
      return {
        TYPE: 'I',
        REF_KEY: this.rowData.REFERENCE_KEY,
        TAX_YEAR: globalParams.tax_year,
        SCENARIO: globalParams.scenario,
        JCD_KEY: globalParams.jcd_key,
        OLD_CHART_KEY: this.rowData.CHART_KEY,
        NEW_CHART_KEY: this.rowData.CHART_KEY,
        OLD_TEMPLATE: modalT_key,
        NEW_Template: modalT_key,
        OLD_USER_M1_DESCRIPTION: this.userm1,
        NEW_USER_M1_DESCRIPTION: this.userm1,
        OLD_SCHDM_TYPE: schdm_type_key,
        NEW_SCHDM_TYPE: schdm_type_key,
        OLD_TBBS_ACCT_KEY: tbbs_key,
        NEW_TBBS_ACCT_KEY: tbbs_key,
        SOURCE_SYSTEM_FLAG: 'D',
        LOCAL_ACCT_KEY: this.rowData.POSTING_ACCT_KEY,
        NEW_COMBINATION_KEY: this.rowData.COMBINATION_KEY,
        OLD_COMBINATION_KEY: this.rowData.COMBINATION_KEY,
        OLD_BEGIN_YEAR: this.beginYear,
        NEW_BEGIN_YEAR: this.beginYear,
        OLD_END_YEAR: this.endYear,
        NEW_END_YEAR: this.endYear,
        OLD_TAX_YEAR: this.viewAdjustmentScheduleArray[i].year,
        NEW_TAX_YEAR: this.viewAdjustmentScheduleArray[i].year,
        OLD_ADJ_AMOUNT: this.viewAdjustmentScheduleArray[i].value,
        NEW_ADJ_AMOUNT: this.viewAdjustmentScheduleArray[i].value,
        OLD_ANNUAL_AMT: this.annual_adjustment_amount,
        NEW_ANNUAL_AMT: this.annual_adjustment_amount,
        OLD_POSTING_ACCT_KEY: posting_acct_key,
        NEW_POSTING_ACCT_KEY: posting_acct_key,
        NEW_POSTING_TAC_KEY: this.posting_tac_key,
        OLD_POSTING_TAC_KEY: this.posting_tac_key,
        SCHDM_ID: this.schdmid
      };
    } else {
      let modalT_key = '';
      let tbbs_key = '';
      let posting_acct_key = '';
      let schdm_type_key = '';
      let schdm_type_key_old = '';
      
      for (const t of this.mainmodaldata_t) {
        if (t.SCHDM_TEMPLATE === this.template) {
          modalT_key = t.SCHDM_TEMPLATE_ID;
          break;
        }
      }
      
      for (const tb of this.tbbsacctdataMain) {
        if (tb.TAX_STREAM_ACCT === this.tbbsacctval) {
          tbbs_key = tb.TAX_STREAM_ACCT_SAVE;
          break;
        }
      }
      
      for (const pt of this.postinggl_acct_M) {
        if (pt.GL_ACCT === this.postingGL) {
          posting_acct_key = pt.GL_ACCT_KEY;
          break;
        }
      }
      
      for (const z of this.schdmtypedata) {
        if (z.SCHDM_TYPE === this.schdmt) {
          schdm_type_key = z.SCHDM_TYPE_SAVE;
          break;
        }
      }
      
      for (const zz of this.schdmtypedata) {
        if (zz.SCHDM_TYPE === this.old_schdmt) {
          schdm_type_key_old = zz.SCHDM_TYPE_SAVE;
          break;
        }
      }
      
      if (!modalT_key || !tbbs_key || !posting_acct_key || !schdm_type_key) {
        this.showSnackBar('Please correct the errors below', 'error');
        this.crudLoading = false;
        throw new Error('This is not an error. This is just to abort javascript!');
      }
      
      return {
        TYPE: 'E',
        REF_KEY: this.rowData.REFERENCE_KEY,
        TAX_YEAR: globalParams.tax_year,
        SCENARIO: globalParams.scenario,
        JCD_KEY: globalParams.jcd_key,
        OLD_TEMPLATE: this.old_template_id,
        NEW_Template: modalT_key,
        OLD_USER_M1_DESCRIPTION: this.old_userm1_desc,
        NEW_USER_M1_DESCRIPTION: this.userm1,
        OLD_SCHDM_TYPE: schdm_type_key_old,
        NEW_SCHDM_TYPE: schdm_type_key,
        OLD_TBBS_ACCT_KEY: this.old_tbbs_acct,
        NEW_TBBS_ACCT_KEY: tbbs_key,
        SOURCE_SYSTEM_FLAG: 'D',
        OLD_CHART_KEY: this.rowData.CHART_KEY,
        NEW_CHART_KEY: this.rowData.CHART_KEY,
        LOCAL_ACCT_KEY: this.rowData.POSTING_ACCT_KEY,
        NEW_COMBINATION_KEY: this.rowData.COMBINATION_KEY,
        OLD_COMBINATION_KEY: this.rowData.COMBINATION_KEY,
        OLD_BEGIN_YEAR: this.old_beginYear,
        NEW_BEGIN_YEAR: this.beginYear,
        OLD_END_YEAR: this.old_endYear,
        NEW_END_YEAR: this.endYear,
        OLD_TAX_YEAR: this.viewAdjustmentScheduleArray[i].old_year,
        NEW_TAX_YEAR: this.viewAdjustmentScheduleArray[i].year,
        OLD_ADJ_AMOUNT: this.viewAdjustmentScheduleArray[i].old_value,
        NEW_ADJ_AMOUNT: this.viewAdjustmentScheduleArray[i].value,
        OLD_ANNUAL_AMT: this.old_annual_adjustment_amount,
        NEW_ANNUAL_AMT: this.annual_adjustment_amount,
        OLD_POSTING_ACCT_KEY: this.old_posting_acct_key,
        NEW_POSTING_ACCT_KEY: posting_acct_key,
        NEW_POSTING_TAC_KEY: this.posting_tac_key,
        OLD_POSTING_TAC_KEY: this.old_posting_tac_key,
        SCHDM_ID: this.schdmid
      };
    }
  }

  showSnackBar(message: string, type: string): void {
    const panelClass = type === 'error' ? 'error-snackbar' :
      type === 'success' ? 'success-snackbar' :
        type === 'info' ? 'info-snackbar' : 'warning-snackbar';
    
    this.snackBar.open(message, 'Close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

  isTemplateDisabled(): boolean {
    return !this.template ||
      this.template === '' ||
      this.template === '----------Preferred Templates---------' ||
      this.template === '-------Non Preferred Templates-------';
  }

  // Helper method to get unique values from array
  getUniqueAdjs(arr: any[], key: string): any[] {
    return _.uniqBy(arr, key);
  }
}

